import * as React from 'react';
import { ClassValue } from 'classnames/types';
import classNames from 'classnames';

interface IFieldErrorProps {
  children: string;
  className?: ClassValue
}

const FieldError = ({ children, className }: IFieldErrorProps) => (
  <div className={classNames('f5 font-bold has-text-danger', className)}>{children}</div>
);

export default FieldError;



// WEBPACK FOOTER //
// ./src/components/FormElements/FieldError.tsx